import styled from 'styled-components';
import { colors } from 'globalStyles';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled.label`
  color: ${colors.DARK};
  font-size: 12px;
  font-weight: normal;
`;

export const InputWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
`;

export const Input = styled.input`
  display: none;
`;

export const Indicator = styled.div`
  position: absolute;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.LIGHT_GRAY};
  border: 1px solid ${colors.LIGHT_GRAY};
  border-radius: 20px;

  &:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 0;
    bottom: 0;
    background-color: ${colors.WHITE};
    border: 1px solid ${colors.LIGHT_GRAY};
    border-radius: 50%;
  }

  ${({ value, disabled, disabledValue }) =>
    (disabled ? disabledValue : value) && `
      background-color: ${colors.GREEN};
      border: 1px solid ${colors.GREEN};

      &:before {
        height: 16px;
        width: 16px;
        left: 19px;
        top: -1px;
        border: 2px solid ${colors.GREEN};
      }
    `
  }
`;



// WEBPACK FOOTER //
// ./src/components/SwitchField/styledComponents.js